export const FLAGS_LIST = 'FLAGS_LIST';
export const FLAGS_LIST_CLEAR = 'FLAGS_LIST_CLEAR';
export const FLAGS_REMOVE = 'FLAGS_REMOVE';